"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Partnership() {
  const headline = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const lede = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const actions = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const footer = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="11515" id="initiate-partnership" className="bg-background text-foreground relative overflow-hidden py-32 md:py-44">
      {}
      <div className="absolute inset-0 bg-cover bg-center opacity-[0.05] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/industrial_grid_structure.webp)]" aria-hidden="true" />
      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse at center, transparent 0%, transparent 30%, hsl(0 0% 3% / 0.95) 80%)"
    }} aria-hidden="true" />

      <div className="relative mx-auto max-w-[1240px] px-6 md:px-12 lg:px-20">
        <div className="mx-auto w-full max-w-[8/12] lg:max-w-[66.666667%]">
          {}
          <h2 ref={headline.ref} className="font-default font-bold text-center tracking-tighter leading-[1.1] text-secondary-foreground" style={{
          fontSize: "clamp(2.5rem, 5vw + 0.5rem, 4.5rem)",
          opacity: headline.isVisible ? 1 : 0,
          transform: headline.isVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 900ms cubic-bezier(0.16, 1, 0.3, 1), transform 900ms cubic-bezier(0.16, 1, 0.3, 1)"
        }}>
            Scale your{" "}
            <span className="text-accent-foreground" style={{
            opacity: headline.isVisible ? 1 : 0,
            transition: "opacity 900ms cubic-bezier(0.16, 1, 0.3, 1) 200ms"
          }}>
              industrial
            </span>{" "}
            market presence.
          </h2>

          {}
          <div className="h-10" />

          {}
          <p ref={lede.ref} className="font-default text-center text-muted-foreground mx-auto leading-[1.6]" style={{
          maxWidth: "56ch",
          fontSize: "clamp(1.125rem, 0.4vw + 1.05rem, 1.25rem)",
          opacity: lede.isVisible ? 1 : 0,
          transform: lede.isVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 720ms cubic-bezier(0.16, 1, 0.3, 1) 150ms, transform 720ms cubic-bezier(0.16, 1, 0.3, 1) 150ms"
        }}>
            MetPro Partners represents elite manufacturers through a technical, data-driven sales framework. We initiate engagements with a direct, confidential assessment of your current sales pipeline.
          </p>

          {}
          <div className="h-14" />

          {}
          <div ref={actions.ref} className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8" style={{
          opacity: actions.isVisible ? 1 : 0,
          transform: actions.isVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 720ms cubic-bezier(0.16, 1, 0.3, 1) 300ms, transform 720ms cubic-bezier(0.16, 1, 0.3, 1) 300ms"
        }}>
            <Link to="/ContactPage" className="w-full sm:w-auto">
              <Button className="group relative w-full sm:w-auto h-auto px-8 py-4 font-default font-bold text-sm bg-accent hover:bg-accent text-accent-foreground border border-accent">
                <span className="relative inline-block">
                  Initiate Assessment
                  <span className="absolute left-0 -bottom-1 h-px bg-foreground transition-all duration-[280ms] ease-[cubic-bezier(0.16,1,0.3,1)] w-[60%] group-hover:w-full" aria-hidden="true" />
                </span>
              </Button>
            </Link>

            <Link to="/ContactPage" className="group inline-flex items-center font-default font-medium text-foreground text-lg relative">
              <span className="relative inline-block">
                Speak with a Principal
                <span className="absolute left-0 -bottom-1 h-px bg-accent transition-all duration-[220ms] ease-[cubic-bezier(0.16,1,0.3,1)] w-[60%] group-hover:w-full" aria-hidden="true" />
              </span>
            </Link>
          </div>

          {}
          <div className="h-[72px]" />

          {}
          <div ref={footer.ref} className="flex flex-col items-center" style={{
          opacity: footer.isVisible ? 1 : 0,
          transform: footer.isVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 720ms cubic-bezier(0.16, 1, 0.3, 1) 450ms, transform 720ms cubic-bezier(0.16, 1, 0.3, 1) 450ms"
        }}>
            <div className="h-px w-[120px] bg-border" aria-hidden="true" />
            <p className="mt-6 font-mono text-muted-foreground uppercase text-center" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.15em"
          }}>
              Technical consultations scheduled within 10 business days
            </p>
          </div>
        </div>
      </div>
    </section>;
}